import React, { ChangeEvent, useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Wrapper, ArrowStyled, CurrentStyled } from './CtaDropdown.styles';
import { CtaDropdownProps, Option } from './CtaDropdown.types';
import { SelectContainerStyled, SelectStyled } from './CtaDropdownMobile.styles';

export const CtaDropdownMobile: React.FC<CtaDropdownProps> = ({
  className,
  onSelectCallback,
  options,
  asSelect,
  defaultValue,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const { t } = useTranslation('common');

  // Need empty str workaround
  const emptyOptionValue = '';

  useEffect(() => {
    const preselectedOption = options.find((option) => option.value === defaultValue);
    if (preselectedOption) {
      setSelectedOption(preselectedOption);
    }
  }, [defaultValue]);

  return (
    <Wrapper asSelect={asSelect} className={className}>
      <CurrentStyled>
        {selectedOption ? selectedOption.label : t('sortByOptionDefault')}{' '}
        <ArrowStyled isOpen={false} />
      </CurrentStyled>
      <SelectContainerStyled>
        <SelectStyled
          defaultValue={defaultValue}
          onChange={(event: ChangeEvent<HTMLSelectElement>) => {
            const selectedOption = options.find(
              (option) => option.value === event.currentTarget.value
            );
            setSelectedOption(selectedOption || null);
            // value is in select option a string
            onSelectCallback(event.currentTarget.value);
          }}
        >
          <option value="">{emptyOptionValue}</option>
          {options?.map((option) => (
            <option key={`cta-option_${option.label}`} value={String(option.value)}>
              {option.label}
            </option>
          ))}
        </SelectStyled>
      </SelectContainerStyled>
    </Wrapper>
  );
};
